const mul = (a, b) => a * b;
export default mul;
